import {AssignmentFilterModel, CustomerAddressModel, CustomerContactDetailsModel, CustomerFilterModel, CustomerModel, Input, SuperBit_swaggerClient, TreatmentFilterModel, TreatmentModel} from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

import moment from 'moment';

export class CustomerCardModel {
    client:any;
    constructor() {
        //this.client = new SuperBit_swaggerClient("http://api.dev-alt.superbit.co.il");
        const apiUrl = localStorage.getItem('apiUrl');
        this.client = new SuperBit_swaggerClient(apiUrl ? apiUrl : generalSettings.apiUrl);
    }

    async getOptions () {
        return this.client.customerCardIndex()
    }

    async filter (filter: CustomerFilterModel) {
        return this.client.customerCardFilter(filter);
    }

    async getCustomerCardDetails (id: string) {
        return this.client.customerCardCustomerDetails(
            {
                id
            }
        )
    }

    async getEditPersonalData (id: string) {
        return this.client.customerCardEditPersonalData(id);
    }

    async savePersonalData (customer: CustomerModel) {
        return this.client.customerCardEditPersonalDataNew(customer);
    }

    async getEmptyCustomerData () {
        return this.client.customerCardAddCustomer();
    }

    async addPersonalData (customer: CustomerModel) {
        return this.client.customerCardAddCustomer2(customer);
    }

    async deletePersonalData (body: Input) {
        //  Input = {id: '0000-0000-...'};
        // customerCardCustomerDelete
        // return this.client.customerCardCustomerDetailsDelete(body);
        return this.client.customerCardCustomerDelete(body);
    }

    async updateCustomerAddressDetails(body: CustomerAddressModel[]) {
        return this.client.customerCardUpdateCustomerAddress(body);
    }

    async deleteCustomerAddressDetails(body: Input) {
        //  Input = {id: '0000-0000-...'};
        return this.client.customerCardCustomerAddressDelete(body);
    }

    async updateCustomerContactDetails(body: CustomerContactDetailsModel[]) {
        return this.client.customerCardUpdateCustomerContactDetails(body);
    }

    async treatmentsFilter(request: TreatmentFilterModel) {
        // console.log('treatmentsFilter');
        // const r: any = request;
        // if (request.dateTo) {
        //     r.dateTo = this.formatDate(request.dateTo);
        // }
        // if (request.dateFrom) {
        //     r.dateFrom = this.formatDate(request.dateFrom);
        // }
        return this.client.treatmentsFilter(request);
    }

    async assignmentsFilter(request: any) {
        return this.client.assignmentsFilter(request);
    }
    // assignmentsFilter

    async speakComFilter(request: any) {
        return this.client.customerCardGetSpeakCom(request);
    }

    async customerDocumentsFilter(request: any) {
        return this.client.customerDocumentsFilter(request);
    }

    async upsertAssignment(data: any) {
        return this.client.tasksUpsertAssignment(data);
    }
    // treatmentsGetAssignment

    async getAssignment(id: string) {
        return this.client.treatmentsGetAssignment(id);
    }

    async deleteAssigment(id: string) {
        return this.client.treatmentsDeleteTreatment(id)
    }
    
    async getAssignmentStatuses() {
        return this.client.getAssignmentStatuses();
    }

    async addAssignmentStatus(body: any) {
        return this.client.addAssignmentStatus(body);
    }

    async deleteAssignmentStatus(id: string) {
        return this.client.deleteAssignmentStatus(id);
    }
    
    async setAssignmentStatus(id: string, status: string) {
        return this.client.setAssignmentStatus({
            id,
            status
        });
    }
    
    async setAssignmentSeen(id: string) {
        return this.client.setAssignmentSeen({
            id,
            seen: true
        });
    }

    
    async getAssignmentTemplates() {
        return this.client.getAssignmentTemplates();
    }

    async addAssignmentTemplate(body: any) {
        return this.client.addAssignmentTemplate(body);
    }

    async deleteAssignmentTemplate(id: string) {
        return this.client.deleteAssignmentTemplate(id);
    }

    async getNewAssignments(id: string) {
        return this.client.treatmentsGetNewAssignments(id);
    }

    async signingFilter(request: any) {
        return this.client.signingFilter(request)
    }
    async signingDelete(request: any) {
        return this.client.signingFilter(request)
    }

    formatDate(d: Date) {
        if (d) {
            return moment(d).format('YYYY-MM-DD');
        }
        return undefined; 
    }

    getTrearmentTypes(){
        return this.client.getAppDictionaryList("TreatmentType");
    }

    getRelationsTypes(){
        return this.client.getAppDictionaryList("RelationType");
    }

    getRelationTypes(){
        return this.client.getAppDictionaryList("RelationType");
    }

    async treatmentsForUpsert(body: any){
        return this.client.treatmentsForUpsert(body);
    }

    treatmentsLoadRelations(customerId: string){
        return this.client.treatmentsLoadRelations(customerId);
    }

    async treatmentsUpsertTreatment(body: TreatmentModel){
        return this.client.treatmentsUpsertTreatment(body);
    }

    async customerDocumentsUploadFile(body: any){
        return this.client.customerDocumentsUploadFile(body);
    }

    async treatmentGetByMessageId(messageId: string){
        return this.client.treatmentGetByMessageId(messageId);
    }

    async treatmentsGetById(id: string){
        return this.client.treatmentsGetById(id);
    }

    async customerDocumentsDelete(id: string){
        return this.client.customerDocumentsDelete(id);
    }

    async policyUpdatePolicy(body: any) {
        return this.client.policyUpdatePolicy(body);
    }

    async customerDocumentsGetFoldersForCustomer(customerId: string) {
        return this.client.customerDocumentsGetFoldersForCustomer(customerId);
    }

    async customerDocumentsCreateFolder(body: any) {
        return this.client.customerDocumentsCreateFolder(body);
    }

    async customerDocumentsGetTitles(){
        return this.client.customerDocumentsGetTitles();
    }

    async customerDocumentsCreateTitle(body: any) {
        return this.client.customerDocumentsCreateTitle(body);
    }

    async customerDocumentsGetByRelation(relationId: string) {
        // body = {relationId: '0000-0000-...'}
        return this.client.customerDocumentsGetByRelation(relationId);
    }


    async customerDocumentsCreateFile(body: any) {
        return this.client.customerDocumentsCreateFile(body);
    }   

    async customerDocumentsDeleteFolder(id: string) {
        return this.client.customerDocumentsDeleteFolder(id);
    }

    async customerDocumentsUpdate(body: any) {
        return this.client.customerDocumentsUpdate(body);
    }

    async customerDocumentsCreateRelation(body: any) {
        // body = {customerDocumentId: '0000-0000-...', relationId: '0000-0000-...', type: 1}
        return this.client.customerDocumentsCreateRelation(body);
    }

    async customerDocumentsDeleteFile(id: string) {
        return this.client.customerDocumentsDeleteFile(id);
    }


    // customerCardCustomerDetailsDelete
    // async deleteCustomerContactDetails(body: Input) {
    //     //  Input = {id: '0000-0000-...'};
    //     return this.client.customerCardCustomerAddressDelete(body);
    // }

}